import {Component, inject, Input, ViewChild} from '@angular/core';
import {AbstractControl} from "@angular/forms";
import {StudentTicketMandateHolderDto} from "../../../models/student-ticket/payment/StudentTicketMandateHolderDto";
import {TranslateService} from "@ngx-translate/core";
import {AbstractFormModalComponent} from "../../../shared/modal/abstract-form-modal.component";
import {ModalShellComponent} from "../../../shared/modal/modal-shell/modal-shell.component";
import {MandateHolderFormComponent} from "../../../shared/mandate-holder-form/mandate-holder-form.component";

@Component({
  selector: 'app-mandate-holder-modal',
  templateUrl: './mandate-holder-modal.component.html',
  styleUrls: ['./mandate-holder-modal.component.scss'],
  imports: [
    ModalShellComponent,
    MandateHolderFormComponent
  ],
  standalone: true
})
export class MandateHolderModalComponent extends AbstractFormModalComponent {

  @Input() initialValues: StudentTicketMandateHolderDto;

  protected validationErrorKey = 'TICKET_MANDATE_HOLDER_DATA';

  @ViewChild(MandateHolderFormComponent) private mandateHolderForm: MandateHolderFormComponent;

  private readonly translate = inject(TranslateService);

  protected get form(): AbstractControl {
    return this.mandateHolderForm?.form;
  }

  override save(): void {
    this.mandateHolderForm.markAllAsTouched();
    if (this.form && this.form.valid) {
      this.activeModal.close(this.getCloseValue());
    } else {
      const entityNameTranslated: string = this.translate.instant('COMPOSITE-MESSAGE.DERDIEDAS.' + 'TICKET_MANDATE_HOLDER_DATA');
      const errorMessage: string = entityNameTranslated + this.translate.instant('COMPOSITE-MESSAGE.UNVOLLSTAENDIG_PLURAL');
      this.customToastService.showError(errorMessage + ' Ungültige Felder: ' + this.mandateHolderForm.getInvalidFieldLabels());
    }
  }

  protected getCloseValue(): unknown {
    return this.mandateHolderForm.getFormValue();
  }
}
